// Toggle the menu open and close when on mobile
export default function menuOpen() {
    const burgerButton = document.querySelector('.gh-burger');
    const head = document.querySelector('#gh-head');

    if (!burgerButton || !head) return;

    burgerButton.addEventListener('click', function () {
        const isOpen = head.classList.toggle('is-open');
        burgerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
}
